import { NavLink } from "react-router-dom";
import "../styles.css";
import logoWhite from "./img/logo.png";

function Header() {
  const closeMobileMenu = () => {
    const navbarCollapse = document.querySelector(".navbar-collapse");
    if (window.innerWidth < 992 && navbarCollapse.classList.contains("show")) {
      const bsCollapse = new window.bootstrap.Collapse(navbarCollapse, {
        toggle: false,
      });
      bsCollapse.hide();
    }
  };

  return (
    <nav
      className="navbar navbar-expand-lg navbar-light fixed-top"
      id="mainNav"
    >
      <div className="container px-4 px-lg-5">
        <NavLink
          className="navbar-brand fw-bold"
          to="/"
          onClick={closeMobileMenu}
        >
          <img
            src={logoWhite}
            alt="ChatCGT"
            style={{ height: "3rem", width: "auto" }}
          />
        </NavLink>

        <button
          className="navbar-toggler navbar-toggler-right"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          Menu
          <i className="fas fa-bars"></i>
        </button>

        <div className="collapse navbar-collapse" id="navbarResponsive">
          <ul className="navbar-nav ms-auto align-items-lg-center">
            <li className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
                to="/about"
                onClick={closeMobileMenu}
              >
                About us
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
                to="/services"
                onClick={closeMobileMenu}
              >
                Our Services
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
                to="/info"
                onClick={closeMobileMenu}
              >
                CGT Info
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
                to="/agents"
                onClick={closeMobileMenu}
              >
                Agents/Solicitors
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
                to="/faqs"
                onClick={closeMobileMenu}
              >
                FAQ's
              </NavLink>
            </li>

            {/* Proper CTA button */}
            <li className="nav-item ms-lg-3">
              <a
                className="btn btn-primary btn-sm fw-bold px-3 py-2"
                href="https://chatcgt.typeform.com/to/rUw4Egui"
                target="_blank"
                rel="noreferrer"
              >
                Check your CGT now
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Header;
